import pixel from "@frog/source/views/app/stage/utility/pixel.js"
import * as Objdict from "objdict"

import Colors from "@frog/source/data/colors.js"
import Sizes from "@frog/source/data/sizes.js"

export default function Particles(stage) {
    const views = []
    if(stage.particles != undefined) {
        Objdict.forEach(stage.particles, (particle, particleKey) => {
            const position = particle.position
            // if(particle.image != undefined) {
            //     const position = particle.position
            //     position.z = particle.zOverride || position.z
            //     const pixelPosition = pixel("particle", position)
            //     views.push({
            //         "key": "particle/" + particleKey,
            //         "position": pixelPosition,
            //         "anchor": particle.anchor,
            //         "containerName": "nightTilesContainer",
            //         "opacity": particle.opacity,
            //         "image": particle.image,
            //         "tint": particle.tint,
            //         "rotation": particle.rotation,
            //         "scale": {
            //             "x": particle.scale instanceof Object ? particle.scale.x : particle.scale,
            //             "y": particle.scale instanceof Object ? particle.scale.y : particle.scale,
            //         },
            //     })
            // } else {
            if(particle.scale != undefined) {
                views.push({
                    "type": "circle",
                    "key": "particle/" + particleKey,
                    "position": pixel("particle", particle.position),
                    "color": particle.color || 0xFFFFFF,
                    "radius": particle.scale, // TODO: WHY IS THIS A RADIUS WHEN IT IS RENDERED LIKE A DIAMETER
                    "anchor": {"x": 0.5, "y": 0.5},
                    // "rotation": particle.rotation,
                })
            } else {
                views.push({
                    "type": "rectangle",
                    "key": "particle/" + particleKey,
                    "position": pixel("particle", particle.position),
                    "color": particle.color || 0xFFFFFF,
                    "width": particle.width,
                    "height": particle.height,
                    // "rotation": particle.rotation,
                })
            }
            // }
        })
    }
    return views
}
